export default __webpack_public_path__ + "static/media/day-4.d0baac60.jpg";